/**
 * @file Boolean input type - checkbox with custom display
 * @version 1.0.0
 */

export const BooleanInputType = {
  name: 'boolean',
  matches: getAttribute => getAttribute('type') === 'boolean',
  displayComponent: {
    name: 'BooleanDisplay',
    props: ['value', 'getAttribute'],
    template: `
      <i class="bi" :class="value ? 'bi-check-circle-fill text-success' : 'bi-x-circle text-muted'"></i>
    `,
  },
  editComponent: {
    name: 'BooleanEdit',
    props: ['value', 'getAttribute', 'validationError', 'fieldId'],
    emits: ['input', 'keydown', 'blur'],
    methods: {
      parseInputValue(event) {
        return event.target.checked;
      },
      handleInput(event) {
        const parsedValue = this.parseInputValue(event);
        this.$emit('input', { target: { value: parsedValue } });
      },
    },
    template: `
      <input
        :id="'field-' + fieldId"
        type="checkbox"
        class="form-check-input me-auto"
        :class="{ 'is-invalid': validationError }"
        :checked="value"
        role="switch"
        @change="handleInput"
      />
    `,
  },
};

export default BooleanInputType;
